/**
 * StepIndicator : indicateur d'étapes horizontal (Photo → Identification → Vérification → Enregistré).
 */
import { Check } from 'lucide-react';

export function StepIndicator({ steps, current }) {
  return (
    <div className="flex items-center gap-2" data-testid="step-indicator">
      {steps.map((label, i) => {
        const done = i < current;
        const active = i === current;
        return (
          <div key={label} className="flex items-center gap-2">
            <span className={`w-6 h-6 rounded-full flex items-center justify-center text-[12px] nums border ${
              active ? 'bg-gold100 border-gold text-gold800' : done ? 'bg-gold border-gold text-white' : 'border-hair text-n500'
            }`}>
              {done ? <Check className="w-3.5 h-3.5" strokeWidth={2} /> : i + 1}
            </span>
            <span className={`text-[13px] ${active ? 'text-ink' : 'text-n500'}`}>{label}</span>
            {i < steps.length - 1 && <span className="w-8 hair-b mx-1" />}
          </div>
        );
      })}
    </div>
  );
}
